import $ from 'jquery'
import React from 'react'
import {paramToHash} from "../queryParams";


const SHORT_FIELD_MAP = {
    "Ding-Name": "Ding",
    "Zitat-Jahr": "Jahr",
    "Zitat-Text": "Text",
    "Zitat-Revolution": "Revolution",
};


export function getQueryDescription(model, field, value, include_mit=true) {
    value = `${value}`;

    let model_field = `${model}-${field}`;

    if (field === "Jahr") {
        value = value.trim();

        let match = /^(\d+)$/.exec(value);
        if (match != null) {
            return `aus dem Jahr ${match[1]}`;
        }

        match = /^(ab|seit)\s(\d+)?$/.exec(value);
        if (match != null) {
            return `ab dem Jahr ${match[2]}`;
        }

        match = /^(\d+)\s?(-|bis)$/.exec(value);
        if (match != null) {
            return `ab dem Jahr ${match[1]}`;
        }

        match = /^(-|bis)\s?(\d+)$/.exec(value);
        if (match != null) {
            return `bis zum Jahr ${match[2]}`;
        }

        match = /^(\d+)\s?(-|bis)\s?(\d+)?$/.exec(value);
        if (match != null) {
            return `in den Jahren ${match[1]} bis ${match[3]}`;
        }

        return `(ungültige Jahresangabe: ${value})`
    }

    if (field === "Revolution") {
        return value === "1" ? 'aus der Kategorie "Revolution"'
                             : 'nicht aus der Kategorie "Revolution"';
    }

    if (SHORT_FIELD_MAP[model_field])
        model_field = SHORT_FIELD_MAP[model_field];

    let ret = `${model_field} = "${value}"`;
    if (include_mit)
        ret = "mit " + ret;
    return ret;
}




/**
 * Place a "link" to the search site.
 * The serach will be initialized with a widget with `model`-`field` and `value`.
 * If `value` is not given, `text` will be used.
 * @returns JSX
 */
function SearchLink({text, textHtml, model, field, value, className, title}) {

    if (!value)
        value = text ? text : textHtml;

    const _onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const hash = paramToHash(model, field, value);
        if (window.location.href.indexOf("/suche/") > 0)
            window.location.hash = hash;
        else
            window.location.href = "/suche/#" + hash;
    };

    if (!title)
        title = `Zeige alle Zitate ${getQueryDescription(model, field, value)}`;

    const klass = "search-link" + (className ? " "+className : "");
    if (textHtml)
        return (
            <a
                className={klass}
                onClick={_onClick}
                title={title}
                dangerouslySetInnerHTML={{__html: textHtml}}
            />
        );
    else
        return (
            <a
                className={klass}
                onClick={_onClick}
                title={title}
            >
                {text}
            </a>
        );
}

export default SearchLink


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/SearchLink.js